import useCurrentUser from "@/hooks/useCurrentUser";
import usePermission from "@/hooks/usePermission";
import Intercom, { boot, update } from "@intercom/messenger-js-sdk";
import dayjs from "dayjs";
import { useRouter } from "next/router";
import { useState, useEffect } from "react";

const APP_ID = "pkb1wr24";

const useIntercom = () => {
  const router = useRouter();
  const [isIntercomInitialised, setIsIntercomInitialised] = useState(false);
  const { currentUser, isLoggedIn } = useCurrentUser();
  const hasIntercomPermission = usePermission("c:intercom");

  const initialiseIntercom = async () => {
    const userForIntercom = {
      name: `${currentUser.firstName} ${currentUser.lastName}`,
      email: currentUser.email,
      created_at: dayjs(currentUser.dateCreated).unix(),
      user_id: currentUser.id,
      plan: currentUser.plan,
    };

    const response = await fetch("/api/intercom", {
      method: "POST",
      body: JSON.stringify(userForIntercom),
    });

    const { token } = await response.json();

    Intercom({
      app_id: APP_ID,
      intercom_user_jwt: token,
      ...userForIntercom,
    });
  };

  useEffect(() => {
    if (!hasIntercomPermission || !isLoggedIn) return;

    if (!isIntercomInitialised) {
      initialiseIntercom();
      setIsIntercomInitialised(true);
    }
  }, [isLoggedIn, hasIntercomPermission, currentUser]);

  // only show intercom launcher on allowed routes
  useEffect(() => {
    const ALLOWED_ROUTES = ["/account"];

    if (ALLOWED_ROUTES.includes(router.pathname)) {
      update({
        hide_default_launcher: false,
      });
    } else {
      update({
        hide_default_launcher: true,
      });
    }

    return () => {
      update({
        hide_default_launcher: false,
      });
    };
  }, [router.pathname]);

  return null;
};

export default useIntercom;
